import { render } from "./SysDebug.vue?vue&type=template&id=b5731990&scoped=true"
import script from "./SysDebug.vue?vue&type=script&lang=js"
export * from "./SysDebug.vue?vue&type=script&lang=js"

import "./SysDebug.vue?vue&type=style&index=0&id=b5731990&lang=less&scoped=true"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5731990"]])

export default __exports__